"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Card = function (_a) {
    var children = _a.children, _b = _a.elevation, elevation = _b === void 0 ? 0 : _b, className = _a.className;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-card", 'ui-card-elevation-' + elevation, className) }, children));
};
exports.default = Card;
